import { KnowledgeBaseResponse } from './types';

const KB_CACHE_KEY = 'kdu-chatbot-kb';

export function getCachedKnowledgeBase(): KnowledgeBaseResponse | null {
  try {
    const raw = localStorage.getItem(KB_CACHE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setCachedKnowledgeBase(data: KnowledgeBaseResponse): void {
  try {
    localStorage.setItem(KB_CACHE_KEY, JSON.stringify(data));
  } catch {
    // localStorage full or unavailable — silently fail
  }
}

export function getCachedVersion(): string | null {
  const cached = getCachedKnowledgeBase();
  return cached?.version ?? null;
}

export function shouldUpdateCache(serverVersion: string): boolean {
  const cachedVersion = getCachedVersion();
  return cachedVersion !== serverVersion;
}
